// controllers/offer_line_item_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    const spinnerElement = document.querySelector("[data-controller~='spinner']")
    if (spinnerElement) {
      this.spinnerController = this.application.getControllerForElementAndIdentifier(spinnerElement, "spinner")
    }
  }

  add(event) {
    const offerId = event.currentTarget.dataset.offerId
    this.spinnerController?.show()

    fetch(`/offers/${offerId}/offer_line_items`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        "Accept": "application/json"
      }
    })
      .then(response => {
        console.log('response status = ' + response.status)
        if (response.ok) {
          return response.json().then(data => {
            this.containerTarget.insertAdjacentHTML("beforeend", data.html)
          })
        } else if (response.status === 401) {
          window.location.reload();
        }
      })
      .finally(() => {
        this.spinnerController?.hide()
      })
  }
}
